import { Badge } from '@chakra-ui/react';
import { memo } from 'react';

import { INVOICE_STATUS_META } from '@features/finance/invoiceMeta';
import type { InvoiceStatus } from 'helpers/fakeData';

interface Props {
  status: InvoiceStatus;
}

const InvoiceStatusBadge = memo(({ status }: Props) => {
  const meta = INVOICE_STATUS_META[status];
  return (
    <Badge size="xs" colorPalette={meta.palette} variant="subtle" borderRadius="full">
      {meta.label}
    </Badge>
  );
});
InvoiceStatusBadge.displayName = 'InvoiceStatusBadge';

export default InvoiceStatusBadge;
